import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';

import { PanelNormalized } from '../../../interfaces/sv-test-pannel';
import { InfoPanelComponent } from '../../../shared/info-panel/info-panel.component';
import { InfoPanelExpansionSectionComponent } from '../../../shared/info-panel/expansion-section-component/info-panel-expansion-section.component';
import { InfoPanelFieldComponent } from '../../../shared/info-panel/field-component/info-panel-field.component';
import { InfoPanelSectionComponent } from '../../../shared/info-panel/section-component/info-panel-section.component';
import { InfoPanelListFieldComponent } from '../../../shared/info-panel/list-field-component/info-panel-list-field.component';
import { UtcDatePipe } from '../../../shared/pipes/utc-date.pipe';

@Component({
  selector: 'app-sv-test-panel-info-panel',
  standalone: true,
  imports: [
    InfoPanelComponent,
    InfoPanelExpansionSectionComponent,
    InfoPanelFieldComponent,
    InfoPanelSectionComponent,
    InfoPanelListFieldComponent,
    UtcDatePipe,
  ],
  templateUrl: './sv-test-panel-info-panel.component.html',
})
export class SvTestPanelInfoPanelComponent {
  @ViewChildren(InfoPanelExpansionSectionComponent) private sections!: QueryList<InfoPanelExpansionSectionComponent>;

  /** The panel row, rendered as-is (same fields the old Get Info modal showed). */
  @Input() panel: PanelNormalized | null = null;

  private _isOpen = false;
  @Input() set isOpen(value: boolean) {
    this._isOpen = value;
    if (!value) {
      setTimeout(() => this.sections?.forEach((s) => s.reset()), 225);
    }
  }
  get isOpen(): boolean {
    return this._isOpen;
  }

  @Output() closed = new EventEmitter<void>();

  get title(): string {
    return this.panel ? $localize`Application Config #${this.panel?.panelId}` : $localize`Application Config`;
  }

  get groups(): string[] {
    return this.panel?.groups.map((group) => group.groupName) ?? [];
  }

  get appNames(): string[] {
    return this.panel?.applications.map((app) => `${app.appName} ${app.version}`) ?? [];
  }
}
